import React, { Component } from 'react';
import { Modal, Checkbox, Radio, Row, Col } from 'antd';
import "./index.scss";
import intl from 'react-intl-universal';

const I18nPrefix = 'Preferences.Content.Signature.Dialog.'

const DocSetting = {
    VerifyOpened: 'verifyOpened',
    UntrustedSignatures: 'untrustedSignatures'
};

const DocSettingOptions = [
    {
        value: DocSetting.VerifyOpened,
        i18nKey: `${I18nPrefix}openVerifyLabel`
    },
    {
        value: DocSetting.UntrustedSignatures,
        i18nKey: `${I18nPrefix}untrustedSignaturesVerifyLabel`
    },
];

const BehaviorSetting = {
    CertificateRevocation: 'certificateRevocation',
    ExpiredTimestamps: 'expiredTimestamps',
    IgnoreDocInfo: 'ignoreDocInfo'
};

const BehaviorSettingOptions = [
    {
        value: BehaviorSetting.CertificateRevocation,
        i18nKey: `${I18nPrefix}certificateRevocation`
    },
    {
        value: BehaviorSetting.ExpiredTimestamps,
        i18nKey: `${I18nPrefix}expiredTimestamps`
    },
    {
        value: BehaviorSetting.IgnoreDocInfo,
        i18nKey: `${I18nPrefix}ignoreDocInfo`
    },
];

const UsingTimeType = {
    CreatedTime: '0',
    SecureTime: '1',
    CurrentTime: '2'
};

const UsingTimeTypeOptions = [
    {
        value: UsingTimeType.CreatedTime,
        i18nKey: `${I18nPrefix}createdTime`
    },
    {
        value: UsingTimeType.SecureTime,
        i18nKey: `${I18nPrefix}secureTime`
    },
    {
        value: UsingTimeType.CurrentTime,
        i18nKey: `${I18nPrefix}currentTime`
    }
]

class SignatureVerification extends Component {

    constructor(props) {
        super(props);
        let { docSettingChecked = [], behaviorSettingChecked = [], usingTimeType } = this.getStateByConfig(props.config);
        this.state = {
            docSettingChecked,
            behaviorSettingChecked,
            usingTimeType
        }
        this.docSettingChange = this.docSettingChange.bind(this);
        this.behaviorSettingChange = this.behaviorSettingChange.bind(this);
        this.usingTimeTypeChange = this.usingTimeTypeChange.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.handleOk = this.handleOk.bind(this);
    }
    

    componentDidMount() {
        
    }

    componentDidUpdate(prevProps) {
        if (prevProps.visible !== this.props.visible) {
            if (this.props.visible) {
                // 打开的时候
                this.setVerifyDataToState();
            }
        }
    }

    setCheckedInfo(isCheck, checkedArr, AllCheckMap, checkValueKey) {
        if (isCheck) {
            if (!checkedArr.includes(AllCheckMap[checkValueKey])) {
                checkedArr.push(AllCheckMap[checkValueKey]);
            }
        } else {
            let index= checkedArr.indexOf(AllCheckMap[checkValueKey]);
            if (index > -1) {
                checkedArr.splice(index, 1);
            }
        }
    }

    getStateByConfig(config = {}) {
        let {
            untrustedAlterInfo,
            verifyDocWhenOpened,
            is_verify_signature,
            use_expired_tst,
            ignore_doc_info,
            time_type,
        } = config;
        let docSettingChecked = [];
        let behaviorSettingChecked = [];
        let usingTimeType = '0';

        this.setCheckedInfo(untrustedAlterInfo, docSettingChecked, DocSetting, 'UntrustedSignatures');
        this.setCheckedInfo(verifyDocWhenOpened, docSettingChecked, DocSetting, 'VerifyOpened');


        this.setCheckedInfo(is_verify_signature, behaviorSettingChecked, BehaviorSetting, 'CertificateRevocation');
        this.setCheckedInfo(use_expired_tst, behaviorSettingChecked, BehaviorSetting, 'ExpiredTimestamps');
        this.setCheckedInfo(ignore_doc_info, behaviorSettingChecked, BehaviorSetting, 'IgnoreDocInfo');

        if (time_type === 0 || time_type) {
            usingTimeType = time_type + '';
        }

        return { docSettingChecked, behaviorSettingChecked, usingTimeType };
    }

    setVerifyDataToState() {
        let { config } = this.props;
        let { docSettingChecked, behaviorSettingChecked, usingTimeType } = this.getStateByConfig(config);
        this.setState({
            docSettingChecked,
            behaviorSettingChecked,
            usingTimeType
        })
    }

    docSettingChange(checkedValues) {
        this.setState({
            docSettingChecked: [...checkedValues]
        })
    }

    behaviorSettingChange(checkedValues) {
        this.setState({
            behaviorSettingChecked: [...checkedValues]
        })
    }

    usingTimeTypeChange(e) {
        this.setState({
            usingTimeType: e.target.value,
        });
    }

    handleClose() {
        this.props.close('cancel')
    }

    getRuleByState() {
        let { config } = this.props;
        let { usingTimeType, docSettingChecked, behaviorSettingChecked = [] } = this.state;
        let rule = {};
        
        rule.verifyDocWhenOpened = docSettingChecked.includes(DocSetting.VerifyOpened);
        rule.untrustedAlterInfo = docSettingChecked.includes(DocSetting.UntrustedSignatures);
        
        rule.is_verify_signature = behaviorSettingChecked.includes(BehaviorSetting.CertificateRevocation);
        rule.use_expired_tst = behaviorSettingChecked.includes(BehaviorSetting.ExpiredTimestamps);
        rule.ignore_doc_info = behaviorSettingChecked.includes(BehaviorSetting.IgnoreDocInfo);
        
        rule.time_type = +usingTimeType;

        return { ...config, ...rule };
    }

    handleOk() {
        let rule = this.getRuleByState();
        this.props.close('ok', rule);
    }

    render() {
        const { visible } = this.props;
        let { docSettingChecked, behaviorSettingChecked, usingTimeType } = this.state;
        return (
            <Modal
                className='SignaturePreferencesDialog'
                maskClosable={false}
                width={555}
                title={intl.formatMessage({ id: `${I18nPrefix}Title` })}
                visible={visible}
                cancelText={intl.formatMessage({ id: 'Preferences.Modal.Cancel' })}
                okText={intl.formatMessage({ id: 'Preferences.Modal.Ok' })}
                onOk={this.handleOk}
                onCancel={this.handleClose}
                centered={true}
            >
                <div className='signature-preferences-container'>
                    <div className="doc-setting">
                        <Checkbox.Group value={docSettingChecked} onChange={this.docSettingChange}>
                            <Row>
                                {
                                    DocSettingOptions.map( ({value, i18nKey}) => (
                                        <Col span={24} key={value}>
                                            <Checkbox value={value}>{intl.formatMessage({ id: i18nKey })}</Checkbox>
                                        </Col>
                                    ))
                                }
                            </Row>
                        </Checkbox.Group>
                    </div>
                    <div className="verify-behavior">
                        <div className="form-title">{intl.formatMessage({ id: `${I18nPrefix}beforeSetTitle` })}</div>
                        <div className="form-panel">
                            <Checkbox.Group value={behaviorSettingChecked} onChange={this.behaviorSettingChange}>
                                <Row>
                                    {
                                        BehaviorSettingOptions.map( ({value, i18nKey}) => (
                                            <Col span={24} key={value}>
                                                <Checkbox value={value}>{intl.formatMessage({ id: i18nKey })}</Checkbox>
                                            </Col>
                                        ))
                                    }
                                </Row>
                            </Checkbox.Group>
                        </div>
                    </div>
                    <div className="verification-time">
                        <div className="form-title">{intl.formatMessage({ id: `${I18nPrefix}verificationTime` })}</div>
                        <div className="form-panel">
                            <div className="sub-title">{intl.formatMessage({ id: `${I18nPrefix}usingTimeType` })}</div>
                            <Radio.Group value={usingTimeType} onChange={this.usingTimeTypeChange}>
                                <Row>
                                    {
                                        UsingTimeTypeOptions.map( ({value, i18nKey}) => (
                                            <Col span={24} key={value}>
                                                <Radio value={value}>{intl.formatMessage({ id: i18nKey })}</Radio>
                                            </Col>
                                        ))
                                    }
                                </Row>
                            </Radio.Group>
                        </div>
                    </div>
                </div>
            </Modal>
        );
    }
}
export default SignatureVerification;